// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactContainer {
  width: 100%;
  min-height: 100vh;
  background: #0c0b20;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 0px;
}

.contactContainer > div {
  width: 100%;
  max-width: 500px;
}

.contactHeader {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
}

.contactHeader p:nth-child(1) {
  color: #c3d32c;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 14px */
}

.contactHeader p:nth-child(2) {
  color: #fff;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 12px */
}

.contactHeader h1 {
  margin: 0;
  font-size: 24px;
}

.contactDetails {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  width: 100%;
}

.contactDetails p:nth-child(1) {
  color: #c3d32c;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 14px */
}

.contactDetails p {
  display: flex;
  align-items: center;
  margin: 5px 0;
  gap: 16px;
}

.contactForm {
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  max-width: 500px;
}

.contactForm .inputGroup {
  display: flex;
  margin-bottom: 0;
  justify-content: space-between;
}

.contactForm .inputWithIcon {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
}

.contactForm .inputWithIcon input,
.contactForm .inputWithIcon textarea {
  border: none;
  background: none;
  color: black;
  width: 100%;
}

.contactForm .inputWithIcon input::placeholder,
.contactForm .inputWithIcon textarea::placeholder {
  color: #656565;
  font-size: 16px;
  font-family: Synonym;
}
.contactForm .inputWithIcon input{
  padding: 10px 10px 10px 32px;
}

.contactForm .inputWithIcon textarea {
  padding: 10px 10px 10px 32px;
}

.contactForm .termsContainer {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.contactForm .termsContainer a {
    color: white;
  }

.termsContainer input {
  margin-right: 10px;
}

.sendButton {
  display: flex;
  padding: 16px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 32px;
  background: #c3d32c;
  color: white;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 21px */
  letter-spacing: 1.82px;
  text-transform: uppercase;
}

.contactDetails p:nth-child(4){
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/assets/Styles/Contact.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;IACI,YAAY;EACd;;AAEF;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".contactContainer {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  background: #0c0b20;\r\n  color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 40px 0px;\r\n}\r\n\r\n.contactContainer > div {\r\n  width: 100%;\r\n  max-width: 500px;\r\n}\r\n\r\n.contactHeader {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  width: 100%;\r\n  padding: 16px;\r\n}\r\n\r\n.contactHeader p:nth-child(1) {\r\n  color: #c3d32c;\r\n  font-family: Lato;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%; /* 14px */\r\n}\r\n\r\n.contactHeader p:nth-child(2) {\r\n  color: #fff;\r\n  font-family: Lato;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%; /* 12px */\r\n}\r\n\r\n.contactHeader h1 {\r\n  margin: 0;\r\n  font-size: 24px;\r\n}\r\n\r\n.contactDetails {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 16px;\r\n  width: 100%;\r\n}\r\n\r\n.contactDetails p:nth-child(1) {\r\n  color: #c3d32c;\r\n  font-family: Lato;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%; /* 14px */\r\n}\r\n\r\n.contactDetails p {\r\n  display: flex;\r\n  align-items: center;\r\n  margin: 5px 0;\r\n  gap: 16px;\r\n}\r\n\r\n.contactForm {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 16px;\r\n  width: 100%;\r\n  max-width: 500px;\r\n}\r\n\r\n.contactForm .inputGroup {\r\n  display: flex;\r\n  margin-bottom: 0;\r\n  justify-content: space-between;\r\n}\r\n\r\n.contactForm .inputWithIcon {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  padding: 10px;\r\n}\r\n\r\n.contactForm .inputWithIcon input,\r\n.contactForm .inputWithIcon textarea {\r\n  border: none;\r\n  background: none;\r\n  color: black;\r\n  width: 100%;\r\n}\r\n\r\n.contactForm .inputWithIcon input::placeholder,\r\n.contactForm .inputWithIcon textarea::placeholder {\r\n  color: #656565;\r\n  font-size: 16px;\r\n  font-family: Synonym;\r\n}\r\n.contactForm .inputWithIcon input{\r\n  padding: 10px 10px 10px 32px;\r\n}\r\n\r\n.contactForm .inputWithIcon textarea {\r\n  padding: 10px 10px 10px 32px;\r\n}\r\n\r\n.contactForm .termsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.contactForm .termsContainer a {\r\n    color: white;\r\n  }\r\n\r\n.termsContainer input {\r\n  margin-right: 10px;\r\n}\r\n\r\n.sendButton {\r\n  display: flex;\r\n  padding: 16px 12px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 4px;\r\n  align-self: stretch;\r\n  border-radius: 32px;\r\n  background: #c3d32c;\r\n  color: white;\r\n  color: #fff;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 150%; /* 21px */\r\n  letter-spacing: 1.82px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.contactDetails p:nth-child(4){\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
